import * as React from 'react';
import ZoomInIcon from '../../images/Icon20_ZoomIn.svg';
import ZoomOutIcon from '../../images/Icon20_ZoomOut.svg';
import FitIcon from '../../images/Icon20_ZoomFitScreen.svg';
import FullScreenIcon from '../../images/Icon20_ZoomFullScreen.svg';
import styles from '../../../../styles/views/plans/PlanVersionPreview.scss';
import { connect } from 'react-redux';
import Button from './Button';
import { __ } from '../../../../core/utils';

import Select from '../Select';
import Line from '../../components/Line';

import Ellipse from '../../components/Ellipse';
import Rect from '../../components/Rect';

import Polygon from '../Polygon';
import Cloud from '../Cloud';
import Delete from '../Delete';
import Task from '../Task/Task';
import Color from '../Color/Color';
import Thickness from '../Thickness/Thickness';
import Pencil from '../Draw/Pencil';
import Highlighter from '../Draw/Highlighter';
import Hand from '../Hand/Hand';

const Toolbar = ({
  fabric_overlay: { viewer, activeTool },
  plan,
  onSubmit,
}) => {
  const basicTools = [
    {
      id: 'zoomIn',
      icon: ZoomInIcon,
      extraClass: ['roundedUp'],
      onClick: () => {
        viewer.viewport.zoomBy(1.2);
        viewer.viewport.applyConstraints();
      },
    },
    {
      id: 'zoomOut',
      icon: ZoomOutIcon,
      onClick: () => {
        viewer.viewport.zoomBy(0.8);
        viewer.viewport.applyConstraints();
      },
    },
    {
      id: 'fit',
      icon: FitIcon,
      onClick: () => {
        viewer.viewport.goHome();
      },
    },
    {
      id: 'fullscreen',
      icon: FullScreenIcon,
      extraClass: ['withSpacer'],
      onClick: () => {
        viewer.setFullScreen(!viewer.isFullPage());
      },
    },
  ];

  if (!plan) return <></>;

  return (
    <div className={styles.OSDToolbar}>
      <Hand plan={plan} />
      <Select plan={plan} />

      {/* Basic tools */}
      {basicTools.map(({ id, icon, onClick, extraClass }) => (
        <Button
          key={id}
          id={id}
          icon={icon}
          onClick={onClick}
          extraClass={[extraClass]}
          label={__('canvas.toolbar.' + id)}
        />
      ))}

      <Task isActive={activeTool == 'task'} plan={plan} />

      <Line isActive={activeTool == 'line'} plan={plan} />

      <Pencil isActive={activeTool == 'pencil'} plan={plan} />
      <Highlighter isActive={activeTool == 'highlighter'} plan={plan} />

      <Ellipse isActive={activeTool == 'ellipse'} plan={plan} />

      <Rect isActive={activeTool == 'rect'} plan={plan} />

      <Polygon isActive={activeTool == 'polygon'} plan={plan} />

      <Cloud isActive={activeTool == 'cloud'} plan={plan} />

      <Color />
      <Thickness />

      <Delete onSubmit={onSubmit} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fabric_overlay: state.fabric_overlay,
  };
};

export default connect(mapStateToProps, null)(Toolbar);
